import { render, staticRenderFns } from "./PostLikeAction.vue?vue&type=template&id=7949b8ee&scoped=true&"
import script from "./PostLikeAction.vue?vue&type=script&lang=js&"
export * from "./PostLikeAction.vue?vue&type=script&lang=js&"
import style0 from "./PostLikeAction.vue?vue&type=style&index=0&id=7949b8ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7949b8ee",
  null
  
)

export default component.exports